import { EUserRoles } from '@models/user';

export const INVENTORY_STORE_SESSION_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING_FOR_AREA_MANAGER: 'WAITING_FOR_AREA_MANAGER',
  WAITING_FOR_ACCOUNTANT: 'WAITING_FOR_ACCOUNTANT',
  APPROVED: 'APPROVED',
  RETURNED: 'RETURNED',
} as const;

// Area manager stage (WAITING_FOR_AREA_MANAGER→WAITING_FOR_ACCOUNTANT/RETURNED): AREA_OWNER only.
// No20_V2 — ADMIN no longer overrides this stage (BE rejects it; only a genuine AREA_OWNER may
// act while a session is still awaiting area manager approval). BE does the final enforcement —
// this only drives button visibility.
export function isAreaManagerRole(role: EUserRoles[] | undefined): boolean {
  if (!role || role.length === 0) {
    return false;
  }
  return role.includes(EUserRoles.AREA_OWNER);
}

// Accountant stage (WAITING_FOR_ACCOUNTANT→APPROVED/RETURNED): ADMIN only — once a session
// reaches this stage, AREA_OWNER has no further say (BE rejects it even if same sector).
export function isAccountantRole(role: EUserRoles[] | undefined): boolean {
  if (!role || role.length === 0) {
    return false;
  }
  return role.includes(EUserRoles.ADMIN);
}
